import { Container, Box, Typography } from "@mui/material";

const PersonalDataCollection: React.FC = () => {
    return (
      <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
        <Box mb={4}>
          <Typography variant="h4" gutterBottom>
            3. Coleta e Uso de Informações Pessoais
          </Typography>
          <Typography variant="body1" paragraph>
            O Usuário declara-se ciente de que o fornecimento de suas informações ocorre de forma consciente, voluntária e expressa, seja por
            meio de formulários físicos ou digitais, seja por entradas de dados em soluções tecnológicas próprias ou de terceiros, ou ainda
            através de sites operados pela INNOVA PLANO DE SAÚDE LTDA.
          </Typography>
          <Typography variant="body1" paragraph>
            As informações e os Dados Pessoais coletados serão tratados em conformidade com os princípios e diretrizes previstos na Lei
            Geral de Proteção de Dados (Lei nº 13.709/2018), sendo mantidos sob estrito sigilo e utilizados exclusivamente para os fins que
            justificaram o cadastro, em observância ao princípio da finalidade e à garantia dos direitos do titular.
          </Typography>
        </Box>
      </Container>
    );
  };
  
  export default PersonalDataCollection;